module.exports = __webpack_public_path__ + "media/images/ui/arrow-down-light-752eb8c99e80a82259e87e65a8536ef4.png";